import Script from 'next/script';

declare global {
  interface Console {
    devlog: (message?: any, ...optionalParams: any[]) => void;
  }
}

const TopcoScript = () => {
  const pLog = console;
  const newCFn = () => {
    const mlist: Console = Object.create(
      Object.getPrototypeOf(console),
      Object.getOwnPropertyDescriptors(console),
    );
    mlist.devlog = (() => {
      if (
        process.env.NODE_ENV === 'development' ||
        (typeof window !== 'undefined' &&
          window?.location.origin.includes('localhost:300'))
      ) {
        return pLog.log;
      } else {
        return () => { };
      }
    })();
    return mlist;
  };
  const newConsole = newCFn();
  console = newConsole;
  return (
    <>
      <Script
        id="microsoft-clarity"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "siqkigoz4h");
          `,
        }}
      />
    </>
  )
};

export default TopcoScript;
